import { render, staticRenderFns } from "./SubCondominiums.vue?vue&type=template&id=792eb59a&scoped=true&"
import script from "./SubCondominiums.vue?vue&type=script&lang=js&"
export * from "./SubCondominiums.vue?vue&type=script&lang=js&"
import style0 from "./SubCondominiums.vue?vue&type=style&index=0&id=792eb59a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792eb59a",
  null
  
)

export default component.exports